import { render, staticRenderFns } from "./select_hust_codes.vue?vue&type=template&id=20f11046&scoped=true"
import script from "./select_hust_codes.vue?vue&type=script&lang=js"
export * from "./select_hust_codes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f11046",
  null
  
)

export default component.exports